var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewSummaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 39,
    viewBox: "0 0 29 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6924_3069)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5791,
    y: 8.73059,
    width: 21.4905,
    height: 26.1916,
    fill: "#06A489"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6924_3069)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6924_3069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1064 4.95351H19.2335V3.80198C19.2335 3.25687 18.7915 2.8149 18.2464 2.8149H17.6764C17.5653 1.24365 16.277 0 14.7095 0C13.1789 0 11.8738 1.2651 11.7452 2.8149H10.679C10.1339 2.8149 9.6919 3.25687 9.6919 3.80198V4.95351H6.31251C3.52082 4.95351 1.21973 7.18974 1.21973 9.98143V33.634C1.21973 35.8236 3.03095 37.6084 5.22054 37.6084H24.1983C26.3879 37.6084 28.1991 35.8236 28.1991 33.634V9.98143C28.1992 7.18974 25.8981 4.95351 23.1064 4.95351ZM24.3333 32.6732C24.3333 33.1275 23.965 33.4957 23.5107 33.4957H5.90829C5.45398 33.4957 5.08575 33.1275 5.08575 32.6732V10.2178C5.08575 9.7635 5.45398 9.39527 5.90829 9.39527H23.5107C23.965 9.39527 24.3333 9.7635 24.3333 10.2178V32.6732Z",
    fill: "#06A489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1064 4.95351H19.2335V3.80198C19.2335 3.25687 18.7915 2.8149 18.2464 2.8149H17.6764C17.5653 1.24365 16.277 0 14.7095 0C13.1789 0 11.8738 1.2651 11.7452 2.8149H10.679C10.1339 2.8149 9.6919 3.25687 9.6919 3.80198V4.95351H6.31251C3.52082 4.95351 1.21973 7.18974 1.21973 9.98143V33.634C1.21973 35.8236 3.03095 37.6084 5.22054 37.6084H24.1983C26.3879 37.6084 28.1991 35.8236 28.1991 33.634V9.98143C28.1992 7.18974 25.8981 4.95351 23.1064 4.95351ZM24.3333 32.6732C24.3333 33.1275 23.965 33.4957 23.5107 33.4957H5.90829C5.45398 33.4957 5.08575 33.1275 5.08575 32.6732V10.2178C5.08575 9.7635 5.45398 9.39527 5.90829 9.39527H23.5107C23.965 9.39527 24.3333 9.7635 24.3333 10.2178V32.6732Z",
    stroke: "#06A489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6309 9.40222H16.3397V18.1328H13.6309V9.40222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6211 12.4136H19.3516V15.1223H10.6211V12.4136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.60645,
    y: 30.2211,
    width: 12.76,
    height: 2.01474,
    rx: 1.00737,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.60645,
    y: 25.52,
    width: 12.76,
    height: 2.01474,
    rx: 1.00737,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.60645,
    y: 20.819,
    width: 12.76,
    height: 2.01474,
    rx: 1.00737,
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6924_3069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 38.28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6924_3069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.6084,
    height: 37.6084,
    fill: "white",
    transform: "translate(-4.15234)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6924_3069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.6084,
    height: 37.6084,
    fill: "white",
    transform: "translate(-4.15332)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSummaryIcon);
export default __webpack_public_path__ + "static/media/viewSummaryIcon.1e4a56ed98aa2c1fabde6a372b9e764d.svg";
export { ForwardRef as ReactComponent };